<script>
import loginForm from "../../account/login";
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import {
  notificationMethods,
} from "@/state/helpers";

import appConfig from "@/app.config";
export default {
  page: {
    title: "Login in MNTC",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    loginForm , Header , Footer
  },
  data() {
    return {
      authError: null,
      isAuthError: false,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...notificationMethods,
  },
  mounted() {
  },
};
</script>

<template>
  <div>
    <Header></Header>
    <div class="account-pages my-5">
      <div class="container">
        <div class="row mx-0 justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft bg-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Welcome Back !</h5>
                      <p>Sign in to continue to MNTC.</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img
                        src="@/assets/images/profile-img.png"
                        alt
                        class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <router-link tag="a" to="/">
                    <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                    </div>
                  </router-link>
                </div>
                <b-alert
                    v-model="isAuthError"
                    variant="danger"
                    class="mt-3"
                    dismissible
                >{{ authError }}</b-alert
                >
                <div
                    v-if="notification.message"
                    :class="'alert ' + notification.type"
                >
                  {{ notification.message }}
                </div>

                <login-form></login-form>

                <!-- <div class="mt-3 text-center">
                  <p>
                    Don't have an account ?
                    <router-link
                        tag="a"
                        to="/volunteer-system/create-account"
                        class="fw-medium text-primary"
                    >Create Now
                    </router-link
                    >
                  </p>
                  <p>
                    © {{ new Date().getFullYear() }} MNTC
                  </p>
                </div> -->

              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->

            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
      </div>
    </div>
    <!-- end container-fluid -->
    <Footer></Footer>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
